import { PrintType } from '@/types';

export const isPrintColorColorSpace = (printType: PrintType) =>
  printType.restrictions.colorSpace === 'print_colors';
